import BarChart from '@/charts/BarChart';
import * as Styles from './AverageTimeChart.styles';
import ChartCard from '../ChartCard';
import ChartEmptyState from '../ChartEmptyState';
import ChartHeader from '../ChartHeader';
import Loading from '../general/Loading';

type ChartItemType = {
  total: number;
  name: string;
  percentage: number;
};

type AvgTimeInDaysType = {
  data: ChartItemType[];
  isLoading: boolean;
};

const AverageTimeChartComponent = function ({ data, isLoading }: AvgTimeInDaysType): JSX.Element {
  return (
    <ChartCard>
      <>
        <ChartHeader
          onSelectFilter={() => {}}
          filterOptions={[]}
          title="Average Time to Acceptance or Rejection in Days"
          tooltipMessage="This chart displays the average number of days that both Trio and our partners take to accept or reject a candidate according to their Main Tech Stacks."
        />
        <Styles.Chart>
          {isLoading && (
            <div style={{ height: 60 }}>
              <Loading />
            </div>
          )}

          {!data.length && !isLoading && (
            <ChartEmptyState title="Ops, we don't have data." subTitle="No results found" />
          )}

          {!!data.length &&
            data.map((item, index) => (
              <BarChart
                key={item.name}
                width={item.percentage}
                label={item.name}
                value={item.total}
                hasOpacity={index % 2 === 1}
              />
            ))}
        </Styles.Chart>
      </>
    </ChartCard>
  );
};

export default AverageTimeChartComponent;
